<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Edit Tag</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="dialog = false">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">What's the name of the Tag?</div>
              <v-text-field
                v-model="name"
                hide-details
                dense
                outlined
                placeholder="Tag Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      dialog: false,
      name: "",

      id: "",
    };
  },
  computed: {
    changeFields() {
      return {
        name: this.name.toLowerCase(),
        id: this.id,
      };
    },
  },
  methods: {
    ...mapActions({
      updateTag: "$_home/updateContent",
      getTags: "$_home/getContent",
    }),
    toggleDialog(details) {
      this.dialog = !this.dialog;
      console.log("opening edit");
      if (this.dialog) {
        console.log(this.details);
        this.name = details.name;
        this.id = details.id;
      }
    },
    cancel() {
      this.dialog = false;
    },
    save() {
      console.log("Save Tag: ", this.changeFields);
      this.updateTag({
        details: this.changeFields,
        collection: "tags",
        type: "Tag",
      }).then(() => {
        this.dialog = false;
        this.getTags({
          collection: "tags",
          mutation: "updateTags",
        });
      });
    },
  },
};
</script>

<style>
</style>